module.exports = __webpack_public_path__ + "static/media/thunderstorm.96cafadc.png";